<div class="banner-edit-modal">
  <div class="modal-header">
    <h2 class="modal-title">Edit Banner</h2>
    <button class="close-btn" (click)="onCancel()" aria-label="Close">×</button>
  </div>

  <div class="modal-content">
    <div class="form-group">
      <label for="bannerName" class="form-label">Banner Name</label>
      <input
        id="bannerName"
        type="text"
        class="form-input"
        [(ngModel)]="bannerCopy.bannerName"
        placeholder="Enter banner name"
      />
    </div>

    <div class="form-group">
      <label for="bannerHeader" class="form-label">Header</label>
      <input
        id="bannerHeader"
        type="text"
        class="form-input"
        [(ngModel)]="bannerCopy.bannerHeader"
        placeholder="Enter header text"
      />
    </div>

    <div class="form-group">
      <label for="bannerCopy" class="form-label">Banner Copy</label>
      <textarea
        id="bannerCopy"
        class="form-textarea"
        [(ngModel)]="bannerCopy.bannerCopy"
        placeholder="Enter banner copy"
        rows="4"
      ></textarea>
    </div>

    <div class="form-row">
      <div class="form-group form-group-half">
        <label for="startDate" class="form-label">Start Date</label>
        <input
          id="startDate"
          type="datetime-local"
          class="form-input"
          [(ngModel)]="bannerCopy.startDate"
        />
      </div>
      <div class="form-group form-group-half">
        <label for="endDate" class="form-label">End Date</label>
        <input
          id="endDate"
          type="datetime-local"
          class="form-input"
          [(ngModel)]="bannerCopy.endDate"
        />
      </div>
    </div>

    <div class="form-group">
      <label for="bannerCountry" class="form-label">Country</label>
      <input
        id="bannerCountry"
        type="text"
        class="form-input"
        [(ngModel)]="bannerCopy.bannerCountry"
        placeholder="Enter country"
      />
    </div>

    <div class="form-group">
      <label for="bannerEnable" class="form-label">Enabled</label>
      <input
        id="bannerEnable"
        type="text"
        class="form-input"
        [(ngModel)]="bannerCopy.bannerEnable"
        placeholder="Enter enabled status"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-save" (click)="onSave()" [disabled]="isSaving">
      {{ isSaving ? 'Saving...' : 'Save' }}
    </button>
    <button class="btn btn-cancel" (click)="onCancel()" [disabled]="isSaving">Cancel</button>
  </div>
</div>
